import { tableCellClasses, TableHead } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const TableHeadWrapper = styled(TableHead)`
    .${tableCellClasses.head} {
        background-color: ${({ theme }) => alpha(theme.palette.primary.light, 0.5)};
    }
`;
